import { BsXLg } from "react-icons/bs";
import logo from "../../../../assets/helius/logo.png";
import { Link } from "react-router-dom";
import MobileMenuStyleWrapper from "./MobileMenu.style";

import { ConnectButton } from "@rainbow-me/rainbowkit";
import DropdownMenu from "../header/DropdownMenu/DropdownMenu";
import { H420_HEADER_ITEMS, HLX_HEADER_ITEMS, JNS_HEADER_ITEMS } from "../header/Header";

const MobileMenu = ({ mobileMenuhandle }) => {
    return (
        <MobileMenuStyleWrapper className="bithu_mobile_menu">
            <div className="bithu_mobile_menu_content">
                <div className="mobile_menu_logo">
                    <img className="bithu_logo" src={logo} alt="bithu logo" />
                    <button className="mobile_menu_close_btn" onClick={() => mobileMenuhandle()}>
                        {" "}
                        <BsXLg />{" "}
                    </button>
                </div>
                <div className="bithu_mobile_menu_list">
                    <DropdownMenu title="H420" links={H420_HEADER_ITEMS} isMobile={true} onClick={mobileMenuhandle} />
                    <DropdownMenu title="HLX" links={HLX_HEADER_ITEMS} isMobile={true} onClick={mobileMenuhandle} />
                    <DropdownMenu title="JNS" links={JNS_HEADER_ITEMS} isMobile={true} onClick={mobileMenuhandle} />
                    <ul>
                        <li>
                            <a href="https://helios.win/treasury">Treasury</a>
                        </li>
                        <li>
                            <a href="https://helios.win/stats">Stats</a>
                        </li>
                        <li>
                            <a href="https://snapshot.org/#/helios-hlx.eth" target="_blank" rel="noopener noreferrer">
                                Governance
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://docs.helios-hlx.win/helios/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => mobileMenuhandle()}
                            >
                                Docs
                            </a>
                        </li>
                    </ul>
                </div>

                <ConnectButton
                    label="Connect Wallet"
                    chainStatus="none" //icon,name,none
                    showBalance={false} //true,false
                    accountStatus="address" //avatar,address,
                    className="connect_btn"
                />
            </div>
        </MobileMenuStyleWrapper>
    );
};

export default MobileMenu;
